"use client";

import Link from "next/link";
import React, { useState, useEffect } from "react";
import { FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa";
import { GetDocumentById } from "@/cms/database-helper";


export default function Footer() {
  const [companyDetails, setCompanyDetails] = useState([]);
  const dbId = process.env.NEXT_PUBLIC_CMS_DB_ID;
  const companyDetailsCollection =
    process.env.NEXT_PUBLIC_PRODUCT_COMPANY_DETAILS_COLLECTION_ID;
  const companyDetailsDOc =
    process.env.NEXT_PUBLIC_PRODUCT_COMPANY_DETAILS_DOCUMENT_ID;

  const [currentYear, setCurrentYear] = useState('');
  useEffect(() => {
    const year = new Date().getFullYear();
    setCurrentYear(year);
  }, []);


  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await GetDocumentById(
          dbId,
          companyDetailsCollection,
          companyDetailsDOc
        );
        if (response.success) {
          const companyDetails = response?.data;
          setCompanyDetails((prevData) => ({
            ...prevData,
            ...companyDetails,
          }));
        } else {
          console.error("Error fetching company details");
        }
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };

    fetchCompanyDetails();
  }, []); // Empty dependency array ensures that this effect runs only once when the component mounts

  return (
    <footer className="bg-neutral-950 border-t-white pt-7 pb-1 ">
      <div className="mx-auto max-w-screen-xl container sm:px-4 md:px-4">
        <div className="flex sm:flex-col">
          <div className="flex flex-row basis-5/12 gap-6 sm:flex-col md:w-6/12 sm:order-3 sm:mt-6">
            <Link
              className="self-start focus:outline-none focus-visible:outline-primary-500"
              href="/"
              aria-label="Home"
            >
              <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 71 80"
                className="h-14 "
              >
                <path
                  d="M68.164 67.473h-.481v-.188h1.189v.188h-.483v1.305h-.225v-1.305ZM70.384 68.155c0-.274.003-.556.01-.715h-.007c-.067.253-.292.868-.46 1.336h-.199c-.128-.386-.36-1.076-.43-1.339h-.006c.011.174.017.5.017.755v.584h-.21v-1.493h.335c.161.45.355 1.026.408 1.224h.002c.035-.153.267-.785.436-1.224h.324v1.493h-.217v-.621h-.003ZM67.593 71.54c-.076-2.651-2.124-2.79-4.142-2.825a224.477 224.477 0 0 0-6.687 0c-2.019.035-4.066.174-4.142 2.825 0 0-.085 1.587-.085 3.06 0 1.27.085 2.456.085 2.456.076 2.652 2.123 2.79 4.142 2.825 1.798.033 4.888.033 6.687 0 2.018-.035 4.066-.173 4.142-2.825 0 0 .085-1.587.085-3.06 0-1.272-.085-2.456-.085-2.456Zm-3.323 4.138c-.042 1.329-1.18 1.397-2.303 1.416-1 .016-2.72.016-3.72 0-1.123-.019-2.263-.087-2.303-1.416 0 0-.047-.593-.047-1.231 0-.736.047-1.533.047-1.533.04-1.33 1.18-1.397 2.303-1.414 1-.016 2.72-.016 3.72 0 1.123.02 2.263.087 2.303 1.414 0 0 .048.593.048 1.23 0 .74-.048 1.534-.048 1.534ZM48.236 75.54l-.005.492c0 .628-.329 1.12-1.34 1.12 0 0-1.934.036-2.581.036-1.939 0-2.363-.097-2.412-.104-.479-.058-.799-.396-.92-.853-.13-.494-.1-1.207-.1-1.831 0-.898.015-1.346.105-1.964.08-.554.56-.98 1.142-.98 0 0 1.21-.07 2.453-.07 1.298 0 2.63.07 2.63.07.46 0 .834.368.834.822v.441l3.36.005c-.005-.68-.014-1.187-.014-1.187-.064-2.418-1.83-2.789-3.716-2.824-1.677-.033-4.57-.094-6.243.038-1.614.126-3.754.154-3.825 2.805 0 0-.095 1.4-.095 2.87 0 1.27.057 2.626.057 2.626.292 2.564 1.976 2.637 3.858 2.763 1.656.113 4.592.097 6.236.015 4.216-.214 3.893-1.587 3.934-4.298l-3.358.008ZM36.574 68.844v10.904h-3.27V71.56h-.53l-4.136 8.187h-2.843L21.66 71.56h-.53v8.187h-3.27V68.842h6.084l3.273 7.15 3.274-7.148h6.083ZM11.13 68.84H5.88L0 79.748h3.91l.99-1.84h7.132l.977 1.84h3.91l-5.79-10.908Zm-4.953 6.7L8.41 71.4h.169l2.196 4.14H6.177Z"
                  fill="#ffffff"
                ></path>
                <path
                  d="M67.655 37.105h-8.602c-1.905 0-3.497-1.414-3.703-3.287l-.372-3.41H50.19l-.372 3.408c-.206 1.875-1.798 3.289-3.703 3.289H40.22c-1.906 0-3.498-1.414-3.704-3.287l-.372-3.41h-4.786l-.372 3.408c-.207 1.875-1.799 3.289-3.704 3.289h-5.89c-1.91 0-3.503-1.416-3.704-3.296l-.363-3.402h-4.779l-.363 3.402c-.2 1.88-1.793 3.298-3.705 3.298H.05V32.81h7.874l.363-3.401c.201-1.88 1.793-3.299 3.703-3.299h5.888c1.91 0 3.503 1.416 3.704 3.296l.365 3.402h4.782l.372-3.409c.206-1.875 1.798-3.289 3.703-3.289H36.7c1.904 0 3.497 1.414 3.703 3.287l.372 3.411h4.786l.372-3.409c.207-1.875 1.799-3.289 3.704-3.289h5.895c1.905 0 3.498 1.414 3.704 3.287l.372 3.411h8.047v4.297Z"
                  fill="#ffffff"
                ></path>
                <path
                  d="M42.094.966c-.272 4.168-3.777 7.455-8.065 7.455-4.235 0-7.718-3.221-8.054-7.347A31.718 31.718 0 0 1 34.223 0c2.715 0 5.353.333 7.871.966ZM60.342 13.36c-6.09 3.32-15.362 5.704-26.498 5.704-10.8 0-19.855-2.246-25.947-5.404a30.365 30.365 0 0 0-3.137 5.617c7.35 3.865 17.587 6.229 29.084 6.229 11.812 0 22.309-2.502 29.69-6.562a30.978 30.978 0 0 0-3.192-5.584Z"
                  fill="#ffffff"
                ></path>
                <path
                  d="M48.575 3.362c-3.486 4.252-8.793 6.981-14.731 6.981A19.018 19.018 0 0 1 19.34 3.641a30.367 30.367 0 0 0-5.438 3.577 25.492 25.492 0 0 0 19.942 9.57c8.238 0 15.577-3.91 20.235-9.945a30.935 30.935 0 0 0-5.504-3.481ZM42.094 62.194c-.272-4.169-3.777-7.455-8.065-7.455-4.235 0-7.718 3.22-8.054 7.347a31.734 31.734 0 0 0 8.25 1.073c2.713 0 5.35-.332 7.87-.965ZM60.342 49.8c-6.09-3.32-15.362-5.704-26.498-5.704-10.8 0-19.855 2.243-25.947 5.401A30.369 30.369 0 0 1 4.76 43.88c7.35-3.866 17.587-6.229 29.084-6.229 11.812 0 22.309 2.504 29.69 6.562a30.838 30.838 0 0 1-3.192 5.586Z"
                  fill="#ffffff"
                ></path>
                <path
                  d="M48.575 59.798c-3.486-4.253-8.793-6.982-14.731-6.982A19.019 19.019 0 0 0 19.34 59.52a30.361 30.361 0 0 1-5.438-3.578 25.492 25.492 0 0 1 19.942-9.569c8.238 0 15.577 3.91 20.235 9.947a31.062 31.062 0 0 1-5.504 3.479Z"
                  fill="#ffffff"
                ></path>
              </svg>
            </Link>
            <div className="flex flex-col space-y-2 w-full">
              <span className="text-xs font-medium text-white sm:text-base">
                AMCO Lubricants
              </span>
              <div className="text-[10px] text-zinc-200">
                {companyDetails && companyDetails.address && (
                  <span
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-primary-500 focus:outline-none focus-visible:outline-primary-500"
                  >
                    {companyDetails.address}
                  </span>
                )}
                <br />
                {companyDetails && companyDetails.phone_number && (
                  <div>
                    Phone:
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      className="transition-colors hover:text-primary-500 focus:outline-none focus-visible:outline-primary-500"
                      href={`tel:${companyDetails.phone_number}`}
                      aria-label={`Call ${companyDetails.phone_number}`}
                    >
                      {companyDetails.phone_number}
                    </Link>
                  </div>
                )}
                {companyDetails && companyDetails.contact_email && (
                  <div>
                    Email:
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      className="transition-colors hover:text-primary-500 focus:outline-none focus-visible:outline-primary-500"
                      href={`tel:${companyDetails.contact_email}`}
                      aria-label={`Email ${companyDetails.contact_email}`}
                    >
                      {companyDetails.contact_email}
                    </Link>
                  </div>
                )}
              </div>
              <div className="social-icons flex gap-4">
                <Link
                  href="https://www.linkedin.com/company/amco-lubricants"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedin className="text-white hover:text-primary-500" />
                </Link>
                <Link
                  href="https://www.facebook.com/profile.php?id=100076145885096"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebook className="text-white hover:text-primary-500" />
                </Link>
                <Link
                  href="https://www.instagram.com/amcolube/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram className="text-white hover:text-primary-500" />
                </Link>
              </div>

              <p className="text-[10px] text-gray-400 pb-4">
              Copyright © AMCO Lubricants {currentYear}. All rights reserved.
              </p>
              
            </div>
          </div>
          <div className="flex gap-4 flex-col basis-3/12 md:w-2/12 sm:mt-8 sm:order-1">
            <div className="text-slate-300 text-[10px] font-bold font-campton-bold leading-[10px]">
              Main Pages
            </div>
            <Link
              className="text-zinc-200 text-xs font-bold font-campton-bold leading-[14.12px]"
              href="/"
            >
              Home
            </Link>
            <Link
              className="text-zinc-200 text-xs font-bold font-campton-bold leading-[14.12px]"
              href="/our-story"
            >
              Our Story
            </Link>
            <Link
              className="text-zinc-200 text-xs font-bold font-campton-bold leading-[14.12px]"
              href="/contact"
            >
              Contact
            </Link>
          </div>
          <div className="flex gap-4 flex-col basis-4/12 md:w-4/12 sm:mt-8 sm:order-2">
            <div className="text-slate-300 text-[10px] font-bold font-campton-bold leading-[10px]">
              Product Pages
            </div>
            <div className="flex flex-row flex-wrap sm:flex-col">
              <Link
                className="text-zinc-200 text-xs font-bold font-campton-bold leading-[14.12px] w-1/2 pb-4 sm:w-full"
                href="/products"
              >
                Products Home
              </Link>
              <Link
                className="text-zinc-200 text-xs font-bold font-campton-bold leading-[14.12px] w-1/2 pb-4 sm:w-full"
                href="/products"
              >
                Hydraulic Oils
              </Link>
              <Link
                className="text-zinc-200 text-xs font-bold font-campton-bold leading-[14.12px] w-1/2 pb-4 sm:w-full"
                href="/products"
              >
                Petrol Engine Products
              </Link>
              <Link
                className="text-zinc-200 text-xs font-bold font-campton-bold leading-[14.12px] w-1/2 pb-4 sm:w-full"
                href="/products"
              >
                Gear Oils
              </Link>
              <Link
                className="text-zinc-200 text-xs font-bold font-campton-bold leading-[14.12px] w-1/2 pb-4"
                href="/products"
              >
                Diesel Engine Products
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
